import { render, staticRenderFns } from "./IssuesSolvingList.vue?vue&type=template&id=47ce6cb7"
import script from "./IssuesSolvingList.vue?vue&type=script&lang=ts"
export * from "./IssuesSolvingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports